<!-- <app-page-header [cssClass]="'type--1'" [videoBg]="page.videoUrl" [imageUrl]="page.imageUrl ? page.imageUrl : false" [subtitle]="page.subtitle" [title]="page.title"></app-page-header> -->
<!-- <article class="content-page" *ngIf="page$() as page">

<main class="content-page__main">
  <div class="container type--xl">
    <div class="content-page__intro" *ngIf="page.intro">{{ page.intro }}</div>
    <div class="content-page__text" [innerHTML]="page.text | safe"></div>
  </div>
</main>
</article> -->

@if (page$(); as page) {
  <article>
    <header class="section-inset-y header is--content-page" [class.no--image]="!page.imageUrl" [class.no--intro]="!page.intro">
      <div class="container header__inner">
        <div class="header__content" [class.container-xs]="!page.imageUrl">
          <h1 class="h2" [class.mb-0]="!page.intro">
            <span>{{ page.title }}</span>
          </h1>
          @if (page.intro) {
            <p class="type-body-md mt-6 white-space-pre-line text-max-width-xs">
              {{ page.intro }}
            </p>
          }
        </div>
        @if (page.imageUrl) {
          <div class="header__figure">
            <figure class="header__figure__inner">
              <img
                [src]="page.imageUrl | resize: 900 : 700"
                [alt]="page.title"
              />
            </figure>
          </div>
        }
      </div>
    </header>
    @if (page.text || page.videoUrl) {
      <main class="bg-gray-100 section-inset-y content">
        <div class="container-xs">
          @if (page.videoUrl && (cookiePreferences$()?.marketing)) {
            <fstr-youtube-player [src]="page.videoUrl" [config]="{}" [cookies]="cookiePreferences$()?.marketing || false"></fstr-youtube-player>
          }
          @if (page.text | stripEmbed: cookiePreferences$()!) {
            <div class="markdown-content" [innerHTML]="page.text | resizeHtmlImages | stripEmbed: (cookiePreferences$()!) | safe"></div>
          }
        </div>
      </main>
    }
  </article>
}
